import { render, staticRenderFns } from "./AddInstallationQuestionTemplate.vue?vue&type=template&id=4257310d&"
import script from "./AddInstallationQuestionTemplate.vue?vue&type=script&lang=js&"
export * from "./AddInstallationQuestionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports